<script>
import CMSListCard from "@/views/components/cms/CMSListCard.vue";

export default {
  name: "ClearUpList",
  components: {CMSListCard},
  data() {
    return {
      tableItems: null,
      tableHeader: [
        {
          title: "article",
          label: "Titel",
        },
        {
          title: "creator",
          label: "Erstellt von",
        },
        {
          title: "description",
          label: "Beschreibung",
        },
        {
          title: "Action",
          label: "Aktionen",
        }
      ]
    };
  },
}
</script>

<template>
  <CMSListCard
      title="Informationen & Dokumente zum Renten Clear-Up"
      new-button-name="Neue(s) Dokument/Information"
      :list-header="tableHeader"
      :category="1"
      :event-to-call-options="{
        table: tableItems,
        showPath: 'RentenClearUp',
        redirectPath: 'RentenClearUpEdit',
        categoryId: 1,
        deletePath: 'cms/deleteArticle',
        getPath: 'cms/getArticlesByCategory',
        textDelete: 'Artikel wurde erfolgreich gelöscht!',
        textDefaultData: 'renten clear-up'
      }"
   new-button-path="ClearUpNew"></CMSListCard>
</template>

<style scoped>

</style>
